<app-form-select
  [errors]="errors"
  [label]="label"
  [(model)]="model"
  [choices]="_countries"
  [valueName]="'code'"
  [optionName]="'name'"
  (modelChange)="change($event)"
></app-form-select>
